<template>
  <div class="item-list">
    <draggable
      v-model="locPlaylistItems"
      class="item-list"
      tag="div"
      v-bind="dragOptions"
      handle=".handle"
      :disabled="!draggable"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group
        type="transition"
        :name="!drag ? 'flip-list' : null"
      >
        <div
          v-for="item in locPlaylistItems"
          :key="item.id"
          class="item is-fullwidth"
        >
          <div class="container">
            <div class="content">
              <i class="fas fa-grip-vertical handle" />
              <span
                class="item-info"
                @click="$emit('itemClick', item)"
              >
                <span v-text="getCaption(item)" />
                <span
                  v-text="item.song_version ? item.song_version.title : '?'"
                />
              </span>
              <i
                v-if="hasDelete"
                class="fas fa-trash right red action"
                @click="$emit('deleteItem', item)"
              />
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  props: {
    hasDelete: {
      default: false,
      type: Boolean
    },
    draggable: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      drag: draggable
    };
  },
  computed: {
    ...mapGetters({
      playlistItems: "playlistItems"
    }),
    locPlaylistItems: {
      get() {
        return this.playlistItems;
      },
      set(value) {
        this.updatePlaylisItemsOrder(value);
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    getCaption(item) {
      if (item.caption) {
        return item.caption + " : ";
      } else if (item.template_item) {
        return item.template_item.caption + " : ";
      }
    },
    ...mapActions(["updatePlaylisItemsOrder"])
  }
};
</script>

<style lang="scss">
.item {
  border-bottom: 1px solid $grey-lighter;
  padding: 0.5em 0.75em;
}
.item-info {
  cursor: pointer;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.item i.handle {
  cursor: move;
}
i.red {
  color: #e02f2f;
}
i.action {
  cursor: pointer;
}
.right {
  margin-right: 30px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// DraggablePlaylistItems.vue?5db71ba0